// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@west/Overrides/Components/CookiePrivacyPolicyPopup";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 175,
    cssOverrides: {
        drawerContainer: css`
            transform: none !important;
            background: ${color("common.background")};
        `,
        drawerTitle: css`
            visibility: hidden;
            transform: none;
            min-height: 20px;
            max-height: 20px;
        `,
        drawerBody: css`
            background: ${color("common.background")};
            height: auto;
        `,
        drawerContent: css`
            padding: 0;
            margin: 0 auto;
            width: 100%;
            background: ${color("common.background")};
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.container = {
    gap: 10,
    css: css`
        margin: 0 auto;
    `,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    width: 12,
};

cookiePrivacyPolicyPopupStyles.buttonsGridItem = {
    width: 12,
    css: css`
        padding: 30px 0 10px 0;
        display: flex;
        margin-top: 0;
        justify-content: flex-start;

        button {
            margin-right: 20px;
            &,
            span {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 18px;
            }
        }

        button + button {
            margin-right: 0;
            margin-left: 0;
        }

        ${xScreen("lte", "xs")} {
            justify-content: center;
            text-align: center;
            flex-wrap: wrap;
            padding-left: 0;
            padding-right: 0;
            margin-left: 0;
            margin-right: 0;
            padding: 10px 0 5px 0;

            button {
                margin-right: 0;
                margin-left: 0;
                margin-bottom: 10px;
                width: 100%;
            }
        }
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {};

cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "secondary",
};

cookiePrivacyPolicyPopupStyles.messageText = {
    size: 14,
};
